import React, { Component } from "react";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroller";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";


class ImageCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isClicked: false,
    }
  }

  recordClick = () => {
    this.setState(
      prevState => ({ isClicked: !prevState.isClicked }),
      // Callback after state is updated.
      () => {
        if (this.state.isClicked) {
          this.props.parent.setState(prevState => (
            {
              numSelectedImages: prevState.numSelectedImages + 1,
              selectedImageIds: prevState.selectedImageIds + " " + this.props.image_id
            }
          ));
        }
        else {
          this.props.parent.setState(prevState => (
            {
              numSelectedImages: prevState.numSelectedImages - 1,
              selectedImageIds: prevState.selectedImageIds.replace(" " + this.props.image_id, "")
            }
          ));
        }
      }
    );
  }

  render() {
    let fullLink = "//reddit.com" + this.props.permalink;

    // Set border of image card based on whether it is clicked.
    let cardStyle = {
      height: "100%"
    };
    if (this.state.isClicked) {
      cardStyle.border = "3px solid #080";
    }

    return (
      <Col md={3} sm={6} xs={12} style={{ padding: "5px" }}>
        <div className="card" onClick={this.recordClick} style={cardStyle}>
          <img className="card-img-top img-fluid" src={this.props.url} alt={this.props.url} />
          <div className="card-body bg-light" style={{ padding: "10px" }}>
            <span className="card-text" style={{ fontSize: "12px" }}>
                <b>[{this.props.index + 1}] Image ID: {this.props.image_id}</b>
                <a style={{ color: "#2196f3" }} className="float-right" href={fullLink}>[View on Reddit]</a>
            </span>
       	    <br	/>
            <span className="card-text" style={{ fontSize: "16px", color: "#795548" }}>
              <b>{this.props.caption}</b>
            </span>
          </div>
        </div>
      </Col>
    );
  }
}

class Infinitescroll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      annotations: null,
      page: 0,
      table: [],
      hasMoreItems: true,
      isDisplayOrderRandom: true,
      // Count number of clicks on ImageCards, this state variable is changed
      // by children `ImageCard`s.
      numSelectedImages: 0,
      selectedImageIds: " ",
    };

    this.pageLength = 15;
  }

  componentDidMount() {
    this.fetchData();
  }

  toggleDisplayOrder = () => {
    this.setState(
      prevState => (
        {
          isDisplayOrderRandom: !prevState.isDisplayOrderRandom,
          numSelectedImages: 0,
          selectedImageIds: " ",
          annotations: null,
          page: 0,
          table: []
        }
      ),
      // Callback after state is updated.
      () => { this.fetchData(); }
    );
  }

  shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  fetchData = () => {
    axios.get(this.props.dataPath)

      .then((response) => {
        if (this.state.isDisplayOrderRandom) {
          this.setState({ annotations: this.shuffle(response.data.annotations) });
        }
        else {
          this.setState({ annotations: response.data.annotations });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  renderRows = () => {
    let table = this.state.table;
    let page = this.state.page;

    if (this.state.annotations) {
      // Outer loop to create parent
      const final_idx = Math.min((page + 1) * this.pageLength, this.state.annotations.length);
      for (let i = page * this.pageLength; i < final_idx; i++) {
        table.push(this.state.annotations[i]);
      }

      this.setState({
        table: table,
        page: page + 1,
        hasMoreItems: final_idx < this.state.annotations.length ? true : false
      });
    }
  }

  render() {
    const loader = <div className="loader">Loading ...</div>;
    var items = [];
    this.state.table.map((annotation, i) => {
      items.push(
        <ImageCard
          index={i}
          image_id={annotation.image_id}
          subreddit={annotation.subreddit}
          url={annotation.url}
          permalink={annotation.permalink}
          crosspost_parents={annotation.crosspost_parents}
          caption={annotation.caption}
          comments={annotation.comments}
          parent={this}
        />
      );
    });

    // Extract subreddit name and year to display on top of page.
    let pathSplits = this.props.dataPath.split("/");
    let subreddit = pathSplits[pathSplits.length - 1].split("_")[0];
    let year = pathSplits[pathSplits.length - 1].split("_")[1].replace(".json", "");

    // Set the text inside display button toggle.
    let toggleDisplayText = "";
    if (this.state.isDisplayOrderRandom) {
      toggleDisplayText = "Sort by Time";
    }
    else {
      toggleDisplayText = "Sort Randomly";
    }

    return (
      <Container fluid style={{ paddingTop: "5px" }}>
        <Row>
          <Col lg={8} md={8} sm={6}><h2>Explore instances from: {subreddit} ({year})</h2></Col>
          <Col lg={2} md={2} sm={3}>
            <span><b>Selected Images: {this.state.numSelectedImages}</b></span>
          </Col>
          <Col lg={2} md={2} sm={3}>
            <button type="button" class="btn btn-dark" onClick={this.toggleDisplayOrder}>
              {toggleDisplayText}
            </button>
          </Col>
          <Col lg={2} md={2} sm={2}><span><b>Selected IDs:</b></span></Col>
          <Col lg={10} md={10} sm={10}><span>{this.state.selectedImageIds}</span></Col>
        </Row>
        <InfiniteScroll
          class="row"
          pageStart={0}
          loadMore={this.renderRows}
          hasMore={this.state.hasMoreItems}
          loader={loader}>
          {items}
        </InfiniteScroll>
      </Container>
    );
  }
}

export default Infinitescroll;
